var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFolderOpen24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3333 16.0001H32L26.6666 10.6667H10.6666C7.73331 10.6667 5.35998 13.0667 5.35998 16.0001L5.33331 48.0001C5.33331 50.9334 7.73331 53.3334 10.6666 53.3334H53.3333C56.2666 53.3334 58.6666 50.9334 58.6666 48.0001V21.3334C58.6666 18.4001 56.2666 16.0001 53.3333 16.0001ZM53.3333 48.0001H10.6666V21.3334H53.3333V48.0001Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.1438,
    y1: 47.085,
    x2: 42.5778,
    y2: 10.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderOpen24Px);
export default __webpack_public_path__ + "static/media/ic_folder-open_24px.8d0b731308236198ca478a688a8c6011.svg";
export { ForwardRef as ReactComponent };